function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "tx93vn2t4a",
  d: "M5.254 16.455c-.692 0-1.254.57-1.254 1.272C4 18.43 4.562 19 5.254 19c.693 0 1.255-.57 1.255-1.273s-.562-1.272-1.255-1.272M5.254 5C4.562 5 4 5.57 4 6.273s.562 1.272 1.254 1.272c.693 0 1.255-.57 1.255-1.272C6.509 5.57 5.947 5 5.254 5m0 5.818c-.692 0-1.254.57-1.254 1.273s.562 1.273 1.254 1.273c.693 0 1.255-.57 1.255-1.273s-.562-1.273-1.255-1.273m13.847 6.028H9.133c-.496 0-.899.402-.899.898 0 .495.403.897.9.897H19.1c.497 0 .899-.402.899-.897 0-.496-.402-.898-.899-.898m0-5.743H9.133c-.496 0-.899.401-.899.897s.403.897.9.897H19.1c.497 0 .899-.401.899-.897s-.402-.897-.899-.897M8.234 6.256c0-.495.403-.897.9-.897H19.1c.497 0 .899.402.899.897 0 .496-.402.898-.899.898H9.133c-.496 0-.899-.402-.899-.898"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  fill: "currentColor",
  transform: "rotate(90 12 12)",
  xlinkHref: "#tx93vn2t4a"
})));

function SvgIconColumns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColumns);
export default __webpack_public_path__ + "static/media/icon-columns.dd6c7f42.svg";
export { ForwardRef as ReactComponent };